import { setActiveTool } from './toolStore';
import { MECHANICS, MECHANIC_MAP, type MechanicConfig } from '@/data/mechanic';
import { atom } from 'nanostores';

export const $activeItem = atom<string>(MECHANICS[0].id);

export function setActiveItem(item: string) {
  $activeItem.set(item);
  setActiveTool('place');
}

export function getActiveItemConfig(): MechanicConfig<any> {
  return MECHANIC_MAP[$activeItem.get()]!;
}
